module.exports = __webpack_public_path__ + "assets/img/0b2c5de169a41f2190aea33cb41cc91c.png";